import React, { useState } from 'react';
import { motion } from 'framer-motion';
import ZAIIcon from './ZAIIcon';
import AIModal from './AIModal';

const FloatingZAIIcon = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [position, setPosition] = useState({ x: 0, y: 0 });

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    return (
        <>
            <motion.div
                className="fixed z-30 cursor-pointer"
                style={{ bottom: 32, right: 32, x: position.x, y: position.y }}
                drag
                dragMomentum={false} // disables snap-back effect
                onDragEnd={(event, info) => {
                    setPosition({ x: info.point.x - window.innerWidth + 80, y: info.point.y - window.innerHeight + 80 });
                }}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                onClick={toggleModal}
                title="Open AI Assistant"
            >
                <div className="relative w-16 h-16">
                    <motion.div
                        className="absolute inset-0 bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 rounded-full"
                        animate={{
                            scale: [1, 1.2, 1],
                            opacity: [0.5, 0.8, 0.5],
                        }}
                        transition={{
                            duration: 3,
                            repeat: Infinity,
                            ease: 'easeInOut',
                        }}
                    />
                    <div className="relative z-10 w-full h-full flex items-center justify-center">
                        <ZAIIcon />
                    </div>
                </div>
            </motion.div>

            <AIModal isOpen={isModalOpen} onClose={toggleModal} />
        </>
    );
};

export default FloatingZAIIcon;
